import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Invoice } from '../types/invoice';
import { EnvService } from '../services/env.service';


const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class KitchenStockRequirementService {

  orderItems : any[]=[];
  documentNo: string = '';
  
  constructor(private http: HttpClient,private env: EnvService ) { }

    getMaxId() :Observable <any>{
        return this.http.get<any>(`${this.env.apiUrl}/kitchen-stock-requirement/getMaxId`,httpOptions)
        .pipe(catchError(this.handleError));
            
        }

   

   getAll():Observable <any> {
    return this.http.get <any>(`${this.env.apiUrl}/kitchen-stock-requirement`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    getRequirement(docNo):Observable <any> {
      return this.http.get<any>(`${this.env.apiUrl}/kitchen-stock-requirement/${docNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }


    create(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/kitchen-stock-requirement`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    update(docNo,data) : Observable <any>{
      return this.http.put<any>(`${this.env.apiUrl}/kitchen-stock-requirement/update/${docNo}`,data,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    updateStatus(docNo) : Observable <any>{
      return this.http.put<any>(`${this.env.apiUrl}/kitchen-stock-requirement/updateStatus/${docNo}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }



    delete(docNo) : Observable <any>{
      return this.http.put<any>(`${this.env.apiUrl}/kitchen-stock-requirement/${docNo}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }



 

    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       



}
